// src/hooks/usePermissionData.ts
import { useLocation } from "react-router-dom";
import { useUserData } from "./useUserData";
import { useEffect, useState } from "react";

interface MenuPermission {
  isAdd: boolean;
  isEdit: boolean;
  isPrint: boolean;
  isDel: boolean;
  isView: boolean;
  isExport: boolean;
  isRelease: boolean;
  isPost: boolean;
}

export const usePermissionData = () => {
  const location = useLocation();
  const { userData, loading } = useUserData();
  const [permissionData, setPermissionData] = useState<MenuPermission>({
    isAdd: false,
    isEdit: false,
    isPrint: false,
    isDel: false,
    isView: false,
    isExport: false,
    isRelease: false,
    isPost: false,
  });

  useEffect(() => {
    if (!userData) return;

    const userPermissionData = userData.userPermission;
    if (userPermissionData && userPermissionData.length > 0) {
      const menudata = userPermissionData[0]?.parentMenu;

      // If no parent menu found, check if it's a flat structure
      if (!menudata) {
        const directPermission = userPermissionData.find(
          (x: any) => x.path === location.pathname
        );

        if (directPermission) {
          setPermissionData(directPermission);
          return;
        }
      }

      for (let index = 0; index < menudata.length; index++) {
        const childMenudata = menudata[index]?.childMenu;

        if (childMenudata) {
          const pathrow = childMenudata.find(
            (x: any) => x.path === location.pathname
          );

          if (pathrow) {
            setPermissionData(pathrow);
            return;
          }
        }

        // Also check if the parent menu itself matches the path
        if (menudata[index]?.path === location.pathname) {
          setPermissionData(menudata[index]);
          return;
        }
      }
    }
  }, [userData, location]);

  return { permissionData, loading };
};
